import React, { Component } from 'react'
import './style.scss';

export default class HostAppsPage2 extends Component {
    render() {
        return (
           <div className='hostpage'>
             <div className='hostLink'>
                <a className='' href="../../images/a6.apk" download>
                <i class="fas fa-download" style={{marginRight:"1rem"}}></i>
                    Download APK FILE </a>
            </div>

           </div>

        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/HostAppsPage2/index.js